module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Weather/Fog-07f5fc6907888f29386092c6b9a7811b1a38672879adcfeaab9c283eb834ce2a.svg";